{
  "welcome-text-1": "Masticando è nato con un preciso obbiettivo: offrire ai professionisti del settore cinofilo prodotti artigianali di alta qualità per supportare il benessere e l’educazione dei cani. I nostri masticativi sono più di un semplice passatempo, sono strumenti: ",
  "welcome-text-2": "\"EDUCA MASTICANDO\".",
  "welcome-text-3": "Sono pensati per favorire l’equilibrio psicofisico, alleviare lo stress e rafforzare il legame tra cane e conduttore.",
  "welcome-text-contact-us": "Se hai bisogno di informazioni o vuoi diventare un nostro rivenditore, contattaci alla mail: ",
  "welcome-title-about": "Cos`è Masticando?",
  "welcome-slogan": "Masticativi acquistabili esclusivamente da tecnici del settore, progettati per un utilizzo mirato nell’apprendimento, nel comportamento e nel benessere del cane",
  "contact": "Contatti",
  "search": "Cerca",
  "names": "Nomi",
  "accesses": "Accessi",
  "logout": "Logout",
  "light-theme": "Tema chiaro",
  "dark-theme": "Tema scuro",
  "cookie-consent": "Utilizziamo cookie tecnici necessari per il funzionamento del sito.",
  "cookie-consent-1": "Vuoi accettare anche i cookie opzionali? Ci aiutano a migliorare il servizio",
  "cookie-consent-all": "Accetta tutti",
  "cookie-consent-consent": "Accetta tutti",
  "cookie-consent-tech": "Accetta solo tecnici",
  "cookie-consent-title": "Informativa sui cookie",
  "cookie-consent-subtitle": "Impostazioni cookie \uD83C\uDF6A",
  "change-cookie-settings": "Preferenze sui cookie",
  "article-read-more": "Scopri di più",
  "product-title": "Masticativi di qualità, il sostegno educativo che fa la differenza",
  "product-subtitle": "Scopri la nostra selezione di masticativi naturali, studiati per favorire il benessere, l’equilibrio e l’apprendimento del cane. Ogni prodotto è pensato per rispondere alle esigenze dei professionisti e per trasformare la masticazione in un’esperienza educativa di valore.",
  "product-description": "Descrizione",
  "product-disclaimer": "Alimento semplice per cani",
  "product-specs": "Specifiche",
  "product-table": "Preventivo",
  "save": "Salva",
  "reset": "Annulla",
  "reseller-list": "Per saperne di più:",
  "events-list": "Prossimi eventi"
}